import { Injectable } from '@angular/core';

function getWindow(): any {
  return window;
}

@Injectable({
  providedIn: 'root',
})
export class WindowRefService {
  get nativeWindow(): Window {
    return getWindow();
  }

  get nativeWindowLocation(): Location {
    return window.location;
  }

  /**
   * Navigates the top-level window to the specified URL
   * @param url The URL to navigate to
   */
  navigateTopWindow(url: string): void {
    if (this.nativeWindow.top) {
      this.nativeWindow.top.location.href = url;
    }
  }
}
